// Typelizer digest 20f1d81147e9086022608b557ed053db
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /admin/productions/:production_id/scenes/preview */
  preview: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes/preview', params, options),
    method: 'post',
  }),

  /** GET /admin/productions/:production_id/scenes/:id/playback */
  playback: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes/:id/playback', params, options),
    method: 'get',
  }),

  /** POST /admin/productions/:production_id/scenes */
  create: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes', params, options),
    method: 'post',
  }),

  /** GET /admin/productions/:production_id/scenes/new */
  new: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes/new', params, options),
    method: 'get',
  }),

  /** GET /admin/productions/:production_id/scenes/:id/edit */
  edit: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /admin/productions/:production_id/scenes/:id */
  show: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes/:id', params, options),
    method: 'get',
  }),

  /** PATCH /admin/productions/:production_id/scenes/:id */
  update: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /admin/productions/:production_id/scenes/:id */
  destroy: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/admin/productions/:production_id/scenes/:id', params, options),
    method: 'delete',
  }),
}
